module.exports = __webpack_public_path__ + "files/1340ca5c3d61f875760ff9f425e8295f.png";